import React from "react";
import styles from "./main-page.module.scss";
import { Header } from "../../components/header/Header";
import { Outlet } from "react-router-dom";

export const MainPage = () => {
  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};
